const arrows = {
    title: 'Arrows',
    characters: [
        {title: 'leftwards simple arrow', character: '←'},
        {title: 'rightwards simple arrow', character: '→'},
        {title: 'upwards simple arrow', character: '↑'},
        {title: 'downwards simple arrow', character: '↓'},
        {title: 'leftwards double arrow', character: '⇐'},
        {title: 'rightwards double arrow', character: '⇒'},
        {title: 'upwards double arrow', character: '⇑'},
        {title: 'downwards double arrow', character: '⇓'},
        {title: 'leftwards dashed arrow', character: '⇠'},
        {title: 'rightwards dashed arrow', character: '⇢'},
        {title: 'upwards dashed arrow', character: '⇡'},
        {title: 'downwards dashed arrow', character: '⇣'},
        {title: 'leftwards arrow to bar', character: '⇤'},
        {title: 'rightwards arrow to bar', character: '⇥'},
        {title: 'upwards arrow to bar', character: '⤒'},
        {title: 'downwards arrow to bar', character: '⤓'},
        {title: 'up down arrow with base', character: '↨'},
        {title: 'back with leftwards arrow above', character: '🔙'},
        {title: 'end with leftwards arrow above', character: '🔚'},
        {title: 'on with exclamation mark with left right arrow above', character: '🔛'},
        {title: 'soon with rightwards arrow above', character: '🔜'},
        {title: 'top with upwards arrow above', character: '🔝'}
    ]
}

export default arrows